const NON_FAN = ["channel", "group", "supergroup"];
const pad = (n) => String(n).padStart(2, "0");
const hm = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

// Name exactly as on the profile's Telegram (contact/renamed name included); @username only when there is no name.
export const fanTitle = (c) => (NON_FAN.includes(c?.kind) ? c.channel_title : (c?.custom_name || "").trim() || (c?.fan_name || "").trim() || (c?.fan_username ? `@${c.fan_username}` : "Cliente"));

export const isOnline = (st) => st?.kind === "online" && (!st.expires || new Date(st.expires) > new Date());

export function presenceText(st) {
  if (!st) return "";
  if (isOnline(st)) return "online";
  const at = st.kind === "online" ? st.expires : st.at;
  if (at) {
    const d = new Date(at), today = new Date(), y = new Date();
    y.setDate(today.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return `ultimo accesso oggi alle ${hm(d)}`;
    if (d.toDateString() === y.toDateString()) return `ultimo accesso ieri alle ${hm(d)}`;
    return `ultimo accesso il ${pad(d.getDate())}/${pad(d.getMonth() + 1)} alle ${hm(d)}`;
  }
  return { recently: "ultimo accesso di recente", last_week: "ultimo accesso nell'ultima settimana", last_month: "ultimo accesso nell'ultimo mese" }[st.kind] || "";
}
